'use strict'

class SmsAuth {

    constructor() {

        this.getCodeAction = '/auth/sms/api/v1/get-code';
        this.getCodeRetryAction = '/auth/sms/api/v1/get-code-retry';
        this.verifyCodeAction = '/auth/sms/api/v1/verify-code';
        this.isLockedAction = '/auth/sms/api/v1/is-locked';
        this.isAuthAction = '/auth/sms/api/v1/is-auth';
        this.personalAreaAction = '/Lichniy-kabinet';

    }

    showForm() {

        let form = smsAuthView.getInsertPhoneForm({

            action: this.getCodeAction,

        });

        popup.insertData(form);
        popup.open();

        let list = document.querySelectorAll('.phone');
        let nodes = [].slice.call(list);
        nodes.forEach(node => new Corrector(node)); 

    }

    getCode(phone = '', agree = false) {

        if (!agree) {

            let form = smsAuthView.getInsertPhoneForm({

                action: this.getCodeAction,
                error: 'no_agree',

            });

            popup.insertData(form);
            popup.open();

            return false;

        }

        let urlencode = encodeURIComponent;

        fetch(this.getCodeAction + `?phone=${urlencode(phone)}`, {
            method: 'GET',
            credentials: 'same-origin',
        })
            .then(resp => resp.json())
            .then(resp => {

                console.log(resp);
                let form;

                if (resp.status == 'ok') {

                    form = smsAuthView.getInsertCodeForm({

                        action: this.verifyCodeAction,

                    });

                } else {

                    form = smsAuthView.getInsertPhoneForm({

                        action: this.getCodeAction,
                        error: resp.errType,

                    });

                }

                popup.insertData(form);
                popup.open();

                let list = document.querySelectorAll('.phone-v');
                let nodes = [].slice.call(list);
                nodes.forEach(node => new Corrector(node)); 

            });

    }

    getCodeRetry() {

        fetch(this.getCodeRetryAction, {
            method: 'GET',
            credentials: 'same-origin',
        })
            .then(resp => resp.json())
            .then(resp => {

                console.log(resp);
                let form;

                if (resp.status == 'ok') {

                    form = smsAuthView.getInsertCodeForm({

                        action: this.verifyCodeAction,

                    });

                } else {

                    form = smsAuthView.getInsertPhoneForm({

                        action: this.getCodeAction,
                        error: resp.errType,

                    });

                }

                popup.insertData(form);
                popup.open();

                let list = document.querySelectorAll('.phone-v');
                let nodes = [].slice.call(list);
                nodes.forEach(node => new Corrector(node)); 

            })

    }

    verifyCode(code = '') {

        let data = new FormData();
        data.append('code', code);

        fetch(this.verifyCodeAction, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
        })
            .then(resp => resp.json())
            .then(resp => {

                console.log(resp);

                if (resp.status == 'ok') {

                    window.location.href = this.personalAreaAction;

                } else if (resp.errType === 'code_is_lost') {

                    let form = smsAuthView.getLostCodeView({

                        action: this.getCodeRetryAction,
                        error: resp.errType,

                    });

                    popup.insertData(form);
                    popup.open();

                } else {

                    let form = smsAuthView.getInsertCodeForm({

                        action: this.verifyCodeAction,
                        error: resp.errType,

                    });

                    popup.insertData(form);
                    popup.open();

                }

            });

    }

    isLocked() {

        return fetch(this.isLockedAction, {
            method: 'GET',
            credentials: 'same-origin',
        })
            .then(resp => resp.json())
            .then(resp => {

                return resp.data ? true : false;

            })

    }

    isAuth() {

        return fetch(this.isAuthAction, {
            method: 'GET',
            credentials: 'same-origin',
        })
            .then(resp => resp.json())
            .then(resp => {

                return resp.data ? true : false;

            })

    }

}

const smsAuth = new SmsAuth();
